import dynamic from "next/dynamic";
import FixedLoader from 'components/FixedLoader';

const AllNotificationsModal = dynamic(() => import("./Content"), {
  ssr: false,
  loading: () => <FixedLoader />,
});

export default AllNotificationsModal;